/* eslint-disable no-console */
import { useEffect, useState } from "react";
import { useAuthContext } from "../../context/auth";
import { getUsers } from "../../utils";
import "./stylesListaClientesPorEjecutivo.scss";

export const ListaClientesPorEjecutivo = ({ clientes = [], categorias = [], filtroCategoria, filtroCliente }) => {
  const [usuariosEjecutivos, setUsuariosEjecutivos] = useState([]);

  const { pais } = useAuthContext();

  const getPaisCode = (countryName) => {
    switch (countryName.toLowerCase()) {
      case "uruguay":
        return "URU";
      case "chile":
        return "CHI";
      case "perú":
        return "PER";
      default:
        return countryName;
    }
  };

  const getCategoriaNombre = (categoriaId) => {
    const categoria = categorias.find((cat) => cat.id === Number(categoriaId));
    return categoria ? categoria.nombre : "Sin Categoría";
  };

  useEffect(() => {
    const initialize = async () => {
      try {
        const paisCode = getPaisCode(pais);
        const allUsers = await getUsers({});

        // Filter executives by role and country, then exclude those without clients
        const ejecutivosConClientes = new Set(clientes.map((c) => String(c.ejecutivo)));

        const filteredEjecutivos = (allUsers || [])
          .filter(
            (user) =>
              ["comercial", "gerencia"].includes(user.rol) &&
              getPaisCode(user.pais) === paisCode &&
              ejecutivosConClientes.has(String(user.id))
          )
          .sort((a, b) => {
            if (a.rol === "comercial" && b.rol === "gerencia") return -1;
            if (a.rol === "gerencia" && b.rol === "comercial") return 1;
            return 0;
          });
        setUsuariosEjecutivos(filteredEjecutivos);
      } catch (error) {
        console.error("Error initializing:", error);
      }
    };

    if (clientes.length > 0) {
      initialize();
    }
  }, [pais, clientes]);

  const getClientesPorEjecutivo = (ejecutivoId) =>
    clientes.filter(
      (cliente) =>
        String(cliente.ejecutivo) === String(ejecutivoId) &&
        (!filtroCategoria || String(cliente.categoria) === String(filtroCategoria)) &&
        (!filtroCliente || String(cliente.id) === String(filtroCliente))
    );

  if (usuariosEjecutivos.length === 0) {
    return <div>No hay ejecutivos disponibles para {pais}</div>;
  }

  const columnWidth = `${100 / usuariosEjecutivos.length}%`;

  return (
    <div className="cartera-table-container">
      <table className="table table-bordered table-hover table-striped" style={{ tableLayout: "fixed" }}>
        <thead>
          <tr>
            {usuariosEjecutivos.map((ejecutivo) => {
              const clientCount = getClientesPorEjecutivo(ejecutivo.id).length;
              return (
                <th key={ejecutivo.id} className="text-center cartera-th" style={{ width: columnWidth }}>
                  <div>{ejecutivo.nombre}</div>
                  <small>
                    {clientCount === 0
                      ? "Sin Clientes"
                      : `${clientCount} ${clientCount === 1 ? "cliente" : "clientes"}`}
                  </small>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {(() => {
            const maxClients = Math.max(...usuariosEjecutivos.map((ej) => getClientesPorEjecutivo(ej.id).length), 1);

            const rows = [];
            for (let i = 0; i < maxClients; i++) {
              rows.push(
                <tr key={i}>
                  {usuariosEjecutivos.map((ejecutivo) => {
                    const clientesEjecutivo = getClientesPorEjecutivo(ejecutivo.id);
                    return (
                      <td key={ejecutivo.id} className="text-start">
                        {clientesEjecutivo[i] ? (
                          <div>
                            <div>{clientesEjecutivo[i].nombre}</div>
                            {!filtroCategoria && (
                              <small className="text-muted">{getCategoriaNombre(clientesEjecutivo[i].categoria)}</small>
                            )}
                          </div>
                        ) : i === 0 && clientesEjecutivo.length === 0 ? (
                          <span className="text-muted">-</span>
                        ) : null}
                      </td>
                    );
                  })}
                </tr>
              );
            }
            return rows;
          })()}
        </tbody>
      </table>
    </div>
  );
};
